/**
 * フィーチャーフラグ
 *
 * リリース前の機能を環境ごとに出し分ける。
 * 本番公開時はここを変更して Live Update で配信する。
 */
export const featureFlags = {
    // 交通費申請。バックエンドの本番デプロイが完了したため全環境で公開
    transportationExpense: true
}
